import React from "react";
import { Button } from "components/ui/button";
import type { CallScriptTemplate } from "./callScriptTemplates";

interface CallScriptTemplatePickerProps {
  templates: CallScriptTemplate[];
  selectedTemplateId: string | null;
  onSelect: (templateId: string) => void;
}

const CallScriptTemplatePicker: React.FC<CallScriptTemplatePickerProps> = ({
  templates,
  selectedTemplateId,
  onSelect,
}) => {
  return (
    <div className="flex flex-wrap gap-2">
      {templates.map((template) => {
        const isSelected = selectedTemplateId === template.id;
        return (
          <Button
            key={template.id}
            type="button"
            variant="outline"
            size="sm"
            onClick={() => onSelect(template.id)}
            className={
              isSelected
                ? "border-[#005151] bg-[#005151]/10 text-[#005151] hover:bg-[#005151]/15"
                : "border-gray-300 text-gray-700"
            }
          >
            {template.label}
          </Button>
        );
      })}
    </div>
  );
};

export default CallScriptTemplatePicker;
